import React from "react";
import { useSelector } from "react-redux";

const DashboardStandard = () => {
  const totalFixedCost = useSelector((state) => state.totalFixedCost);
  const totalYearGrossMargin = useSelector(
    (state) => state.totalYearGrossMargin
  );
  const totalAnnualSales = useSelector((state) => state.totalAnnualSales);
  const netProfitPerMonth = useSelector(
    (state) => state.salaryCalculation.netProfitPerMonth
  );

  const totalMeasuredCostsYear1 = useSelector(
    (state) => state.TotalMeasuredCostsYear.year1
  );
  const totalMeasuredCostsYear2 = useSelector(
    (state) => state.TotalMeasuredCostsYear.year2
  );
  const totalMeasuredCostsYear3 = useSelector(
    (state) => state.TotalMeasuredCostsYear.year3
  );

  const activeYear = useSelector((state) => state.year);
  function getTotalMeasuredCostsYear() {
    let resultMeasured = 0;
    if (activeYear.year === "year1") {
      resultMeasured = Math.round(
        totalMeasuredCostsYear1 > 0 ? totalMeasuredCostsYear1 : 0
      );
    }
    if (activeYear.year === "year2") {
      resultMeasured = Math.round(
        totalMeasuredCostsYear2 > 0 ? totalMeasuredCostsYear2 : 0
      );
    }
    if (activeYear.year === "year3") {
      resultMeasured = Math.round(
        totalMeasuredCostsYear3 > 0 ? totalMeasuredCostsYear3 : 0
      );
    }
    return resultMeasured;
  }

  return (
    <div className="container-dashboard-mobile">
      <label>Månadslön (netto)</label>
      <output className="dashboard-output-large output-mobile">
        {Math.round(netProfitPerMonth >= 0 ? netProfitPerMonth : 0)}
      </output>
      <div className="container-inner-dashboard-mobile">
        <div className="container-inner-flex-direction">
          <label> Årsförsäljning</label>
          <output className="output-mobile">
            {Math.round(totalAnnualSales >= 0 ? totalAnnualSales : 0)}
          </output>
        </div>
        <div className="container-inner-flex-direction">
          <label>Årstäckningsbidrag</label>
          <output className="output-mobile">
            {Math.round(totalYearGrossMargin >= 0 ? totalYearGrossMargin : 0)}
          </output>
        </div>
      </div>
      <div className="container-inner-dashboard-mobile">
        <div className="container-inner-flex-direction">
          <label>Fasta Kostnader</label>
          <output className="output-mobile">
            {Math.round(totalFixedCost > 0 ? totalFixedCost : 0)}
          </output>
        </div>
        <div className="container-inner-flex-direction">
          <label>Åtgärdskostnader</label>
          <output className="output-mobile">
            {getTotalMeasuredCostsYear()}
          </output>
        </div>
      </div>
    </div>
  );
};
export default DashboardStandard;
